module.exports = __webpack_public_path__ + "static/media/docplaceholder.eaaeaa45.svg";